<app-capture-history-item-title>
  {{ title }}
</app-capture-history-item-title>
<app-capture-history-item-body>
  <p>
    @if (filename) {
      Document <span class="phi">{{ filename }}</span> associated with this capture
    } @else {
      Document associated with this capture
    }
  </p>
</app-capture-history-item-body>
